
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IAPPSTATE } from '@/store/state.d';
import tHeader from './components/tHeader/index.vue';
import tNav from './components/tNav/index.vue';
import tMenu from './components/tMenu/index.vue';

@Component({
  components: {
    tHeader,
    tNav,
    tMenu,
  },
})
export default class Home extends Vue {
  @State app!: IAPPSTATE;

  public $refs!: {
    menu: HTMLElement,
  }
}
